/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Helmet } from 'react-helmet-async';
import type { HelmetProps } from 'react-helmet-async';
import { Route } from 'react-router-dom';
import type { RouteProps } from 'react-router-dom';

type HelmetedRouteProps = RouteProps & {
  helmetProps?: HelmetProps;
};

const HelmetedRoute: React.FC<HelmetedRouteProps> = ({
  helmetProps,
  ...routeProps
}) => (
  <>
    <Helmet {...helmetProps} />
    <Route {...routeProps} />
  </>
);

export default HelmetedRoute;
